
import { Component, Prop, Vue } from 'vue-property-decorator';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import GenericError from '@/components/common/Alerts/GenericError.vue';
import { formattedDate } from '@/utils/dates';
import { submitOneTimePayment } from '@/api/loan';

@Component({
  components: {
    CustomButton,
    CustomDialog,
    GenericError
  }
})
export default class ConfirmPaymentDialog extends Vue {
  @Prop({ type: [String, Number], required: true }) readonly amount!: string | number;

  loading = false;

  showError = false;

  get date() {
    return formattedDate();
  }

  get lastFour() {
    return this.$store.getters['Account/getBankAccountLastFour'];
  }

  async submitPayment() {
    this.loading = true;
    try {
      const { data } = await submitOneTimePayment(Number(this.amount));
      this.$emit('confirm', data.payment_id);
    } catch {
      this.showError = true;
    } finally {
      this.loading = false;
    }
  }
}
